import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "../../styles/Topbar.css";
import { Container, Nav, Navbar, Offcanvas } from "react-bootstrap";

function Sidebar({ show, onHide }) {
  const NavUrl = ({ url, icon, tooltip }) => {
    return (
      <NavLink to={`${url}`} className="top-nav-link">
        <div className="top-nav-item">
          {icon} {tooltip}
        </div>
      </NavLink>
    );
  };

  return (
    <Offcanvas
      placement="start"
      className="sidebar"
      show={show}
      onHide={onHide}
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          {/* <MdSchool className="mr-2" /> */}
          SCALED
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Nav className="flex-column main-nav">
          <NavUrl url="/" tooltip="Dashboard" />
          <NavUrl url="/master" tooltip="Master" />
          <NavUrl url="/daily-activity" tooltip="Daily Activity" />
          <NavUrl url="/record" tooltip="Record" />
          <NavUrl url="/view-record" tooltip="View Records" />
          <NavUrl url="/infant-feeding" tooltip="Infant Feeding" />
          <NavUrl
            url="/interdepartmental-movement"
            tooltip="Interdepartmental Movement"
          />
          <NavUrl url="/microchip" tooltip="Microchip" />
          <NavUrl url="/tracking-device" tooltip="Tracking Device" />
          <NavUrl
            url="/physical-measurements"
            tooltip="Physical Measurements"
          />
          <NavUrl url="/release" tooltip="Release" />
          <NavUrl url="/vet-treatment" tooltip="Vet Treatments" />
          <NavUrl url="/sample" tooltip="Sample" />
          <NavUrl url="/upload" tooltip="Upload" />
        </Nav>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

function Topbar() {
  const [showSidebar, setShowSidebar] = useState(false);

  const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  return (
    <>
      <Navbar variant="dark" fixed="top" className="topbar">
        <Navbar.Toggle onClick={toggleSidebar} />
      </Navbar>
      <Sidebar show={showSidebar} onHide={() => setShowSidebar(false)} />
    </>
  );
}

export default Topbar;
